import { FilterOperator } from '../../api/api.operators';

export const filterOperatorLabels = {
  [FilterOperator.LIKE]: $localize`contains`,
  [FilterOperator.EQ]: $localize`equals`,
  [FilterOperator.NULL]: $localize`has no value`,
  [FilterOperator.IN]: $localize`one of`,
  [FilterOperator.LT]: $localize`less than`,
  [FilterOperator.BTW]: $localize`between`,
  [FilterOperator.LTE]: $localize`less than or equal`,
  [FilterOperator.GTE]: $localize`greater than or equal`,
  [FilterOperator.GT]: $localize`greater than`,
  [FilterOperator.CONTAINS]: $localize`list contains`,
} as const satisfies {
  [o in FilterOperator]: string;
};

export const filterOperatorNotLabels = {
  [FilterOperator.LIKE]: $localize`does not contain`,
  [FilterOperator.EQ]: $localize`does not equal`,
  [FilterOperator.NULL]: $localize`has a value`,
  [FilterOperator.IN]: $localize`none of`,
  [FilterOperator.BTW]: $localize`not between`,
  [FilterOperator.CONTAINS]: $localize`list does not contain`,
} as Record<FilterOperator, string>;
